// src/components/PasswordResetModal.js
// Shows a newly generated transfer password ONCE. Deliberately cannot be dismissed by
// clicking outside, so the sender can't lose it by accident.
import React, { useState } from 'react';

export default function PasswordResetModal({ password, recipientEmail, onClose }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard unavailable — user can select the text */ }
  };

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header"><h3>🔑 New password generated</h3></div>
        <div className="modal-body">
          <p style={{ fontSize: '13px', color: 'var(--g600)', marginBottom: '12px' }}>
            New password for <strong>{recipientEmail}</strong>. The previous password no longer works.
          </p>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '12px', background: 'var(--g50)', border: '1px solid var(--g200)', marginBottom: '12px' }}>
            <code style={{ fontSize: '20px', fontWeight: 800, letterSpacing: '0.12em', color: 'var(--g900)', fontFamily: 'var(--font-mono)', flex: 1, userSelect: 'all', wordBreak: 'break-all' }}>{password}</code>
            <button className="btn btn-secondary btn-sm" onClick={copy} style={{ whiteSpace: 'nowrap' }}>{copied ? '✅ Copied' : '📋 Copy'}</button>
          </div>
          <div className="alert alert-warn" style={{ marginBottom: 0 }}>
            ⚠️ This is shown <strong>once</strong> and can't be retrieved again. Share it with the recipient
            separately — <strong>not by email</strong> (for example by phone or message). If they were part-way through
            opening the link, they'll be asked to enter it again.
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>I've noted it — close</button>
        </div>
      </div>
    </div>
  );
}
